import Select, { components, OptionProps, SingleValue } from 'react-select';
import { useMemo } from 'react';
import type { OptionType } from '../../types/forms.type';

const { Option } = components;

interface InputDropdownParams {
  id: string,
  label: string,
  selected: OptionType,
  options: OptionType[],
  placement: 'top' | 'auto' | 'bottom'
  onChange: (value: SingleValue<OptionType>) => void;
}

function CustomOption(props: Readonly<OptionProps<OptionType, false>>) {
  const { data, label } = props;

  return (
    <Option {...props}>
      <div id={`${label}-${data.value}`} className="flex flex-row">
        <span id={data.value} className="flex-1">{data.label}</span>
        {/* TODO: #LIFT-1480 add in buttons to edit and delete template  */}
      </div>
    </Option>
  );
}

export default function DropdownEdit({
  id, label, selected, options, placement, onChange,
}: Readonly<InputDropdownParams>) {
  const selectedOption = useMemo(
    () => options.find(
      (option: OptionType) => option.value === selected.value,
    ) || null,
    [options, selected],
  );
  return (
    <label htmlFor={id} className="text-secondary text-sm">
      {label}
      <Select<OptionType, false>
        inputId={id}
        name={id}
        getOptionValue={(option) => option.label}
        menuPlacement={placement}
        options={options}
        isSearchable
        isClearable
        isLoading={options.length === 0}
        classNames={{
          control: ({ isFocused }) => `!flex !p-0 input-default ${isFocused ? 'outline-none ring-1 ring-primary border-transparent' : ''} `,
          option: ({ isSelected }) => `p-2 bg-transparent hover:text-secondary hover:hover:bg-pipbg-subtle ${
            isSelected ? 'text-primary-dark hover:bg-pipbg-subtle' : 'text-secondary'
          }`,
          indicatorSeparator: () => 'hidden',
        }}
        styles={{ // keep basic default styles so not all custom
          control: () => ({}),
          option: () => ({}),
        }}
        value={selectedOption}
        onChange={(newValue) => onChange(newValue)}
        components={{ Option: CustomOption }}
      />
    </label>
  );
}
